import { render, staticRenderFns } from "./CustomerManager.vue?vue&type=template&id=2865bb67&scoped=true&"
import script from "./CustomerManager.vue?vue&type=script&lang=js&"
export * from "./CustomerManager.vue?vue&type=script&lang=js&"
import style0 from "./CustomerManager.vue?vue&type=style&index=0&id=2865bb67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2865bb67",
  null
  
)

export default component.exports